import {
  Button,
  ButtonVariant,
  GlobalStyle,
  HeadingL,
  HeadingM,
  HorizontalFlex,
  LayoutBackground,
  ResponsiveGrid,
  Space,
  VerticalFlex,
} from "@enxcs/dap-ui-stratos";
import { FC } from "react";
import i18n from "@/i18n";
import { useNavigate } from "react-router-dom";
import HeaderLogo from "@/components/Header/HeaderLogo";
import useAuth from "@/hooks/useAuth";

const GenericError: FC = () => {
  const navigate = useNavigate();

  const { logOut } = useAuth();

  return (
    <>
      <GlobalStyle base={"/"} />

      <LayoutBackground>
        <ResponsiveGrid $l={`repeat(1, 1fr)`} $gap={Space.V2}>
          <VerticalFlex
            $align="center"
            $gap={Space.V56}
            style={{
              paddingTop: Space.V72,
            }}
          >
            <HeaderLogo onLogoClick={() => navigate(`/${i18n.language}`)} />

            <HorizontalFlex $gap={Space.V32}>
              <div>
                <HeadingL style={{ textAlign: "left" }}>Something went wrong!</HeadingL>
                <HeadingM style={{ textAlign: "left" }}>We've been notified. Our team will fix it as soon as possible</HeadingM>
              </div>
              <Button variant={ButtonVariant.SECONDARY} label="Back" onClick={() => navigate(-1)} />
              <Button label="Logout" onClick={() => logOut()} />
            </HorizontalFlex>
          </VerticalFlex>
        </ResponsiveGrid>
      </LayoutBackground>
    </>
  );
};

export default GenericError;
